import { Alert } from 'reactstrap';

import classNames from 'classnames';

import { ISessionTime, SESSION_TIME, useSessionStorage } from '@hsp/react-hooks';

import cssClasses from './session-time.module.scss';

export const useSessionTime = () => {
  const [sessionTime] = useSessionStorage<ISessionTime>(SESSION_TIME, null);

  return (
    <div className="align-items-center d-flex small">
      <span className="me-1 font-weight-semibold">Session:</span>
      <Alert
        className={classNames(cssClasses.sessionTime, 'align-items-center d-flex justify-content-center mb-0 p-0')}
        color="info">
        {sessionTime?.remaining}
      </Alert>
    </div>
  );
};
